import ModalBase from "../modals/ModalBase";
import { inviteEmailDraft, inviteHref, markInviteSent } from "../../js/api/clientInvite";

export default function SendInviteModal({ invite, isOpen, onClose }) {
  if (!invite) return null;
  const kind = invite.kind === "seller" ? "seller" : "buyer";
  const draft = inviteEmailDraft(invite);

  function send() {
    markInviteSent(invite);
    window.location.href = draft.mailto;
    onClose();
  }

  function copy() {
    const href = inviteHref(invite.token);
    navigator.clipboard
      .writeText(href)
      .then(() => {
        markInviteSent(invite);
        onClose();
      })
      .catch(() => onClose());
  }

  return (
    <ModalBase isOpen={isOpen} title="Send invitation" onClose={onClose} compact quiet>
      <p>
        Send the REChecklist invitation to <strong>{invite.name}</strong>?
      </p>
      <p className="muted">
        The {kind} setup link does not include a Client ID yet. Their ID is created when they finish
        the form, and it stays linked to this advisor.
      </p>
      <div className="btn-row">
        <button type="button" className="primary-btn" onClick={send}>
          Send invitation email
        </button>
        <button type="button" className="ghost-btn" onClick={copy}>
          Copy setup link
        </button>
        <button type="button" className="ghost-btn" onClick={onClose}>
          Cancel
        </button>
      </div>
    </ModalBase>
  );
}
